export const liabilityAndLegalClaims = [
  {
    header: "No Liability for Damages",
    answer:
      "HomeSwap is not liable for any damages related to Listings, Exchanges, platform use, or the accuracy of information on the platform. This includes, but is not limited to: \n \n \
        • Direct, indirect, or general damages. \n \
        • Special, compensatory, incidental, punitive, or consequential damages \n \
        • Losses related to data, profits, clientele, or business interruptions. \n \
        • Personal injury, bodily harm, or emotional distress.",
  },
  {
    header: "Connection to Platform Use",
    answer:
      "HomeSwap will not be responsible for any damages arising from: \n \n \
    • Your use or inability to use the platform \n \
    • Communications or meetings with other Members. \n \
    • The creation of Listings or participation in Exchanges (whether as a Host or Guest Member). \n \
    • Any liability claims, including those based on warranty, contract, tort, negligence, or strict liability, even if HomeSwap was made aware of the possibility of such damages. \n \
    • Key Exchange Responsibility: The responsibility for exchanging keys lies solely with the Owner. HomeSwap holds no liability for any issues that arise from this process.",
  },
  {
    header: "Key Exchange Responsibility",
    answer:
      "The responsibility for exchanging keys lies solely with the Owner. HomeSwap holds no liability for any issues that arise from this process.",
  },
];
